import {Box, Button, Container, SvgIcon, Typography} from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const Page404 =() => {
return (
    <>
      <Box
          component="main"
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexGrow: 1,
            minHeight: '100%'
          }}
      >
        <Container maxWidth="md">
          <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column'
              }}
          >
            <Box
                sx={{
                  mb: 3,
                  textAlign: 'center'
                }}
            >
              <img
                  alt="Under development"
                  src="/error-404.png"
                  style={{
                    display: 'inline-block',
                    maxWidth: '100%',
                    width: 400
                  }}
              />
            </Box>
            <Typography
                align="center"
                sx={{ mb: 3 }}
                variant="h3"
            >
              page not found
            </Typography>
            <Button
                href="/app/feed"
                endIcon={(
                    <SvgIcon fontSize="small">
                      <ArrowBackIosNewIcon />
                    </SvgIcon>
                )}
                sx={{ mt: 3 }}
                variant="contained"
            >
              back to safety
            </Button>
          </Box>
        </Container>
      </Box>
    </>
)
};

export default Page404;
